"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Context = require("../Context");
var actions = _interopRequireWildcard(require("../../actions"));
var _ConfirmationModal = _interopRequireDefault(require("../../../components/ConfirmationModal"));
var _AuthStrategy = require("../../services/AuthStrategy");
var _utils = require("./utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const IdleModal = () => {
  const config = (0, _react.useContext)(_Context.ConfigContext);
  const locale = (0, _react.useContext)(_Context.LocaleContext);
  const auth = config.auth || {};
  const dispatch = (0, _Context.useDispatch)();
  const handleLogout = () => {
    _AuthStrategy.authStrategy.redirectToLogin();
  };
  const handleProlong = () => {
    dispatch(actions.prolongSession(false));
    dispatch(actions.toggleIdleModal(false));
  };
  return _react.default.createElement(_ConfirmationModal.default, {
    active: true,
    onClose: handleLogout,
    onConfirm: handleProlong,
    title: locale.idleTitle,
    message: (0, _utils.getFormattedMessage)(locale.idleText, locale.modalMinutes, locale.modalSeconds, auth.modalDuration),
    confirmButtonLabel: locale.idleConfirm,
    cancelButtonLabel: locale.idleCancel,
    confirmButtonVariant: "primary"
  });
};
var _default = exports.default = IdleModal;